import { IProperty } from "../../../../../shared/interfaces/IProperties";

interface Props {
    propertyInfo?: IProperty;
}

export const StandardUsoSolo: React.FC<Props> = () => {
    return (
        <>
            <div>StandardUsoSolo</div>
            <div>StandardUsoSolo</div>
        </>
    );
};
